import script from "./VcfsTrialBalance.vue?vue&type=script&setup=true&lang=ts"
export * from "./VcfsTrialBalance.vue?vue&type=script&setup=true&lang=ts"

import "./VcfsTrialBalance.vue?vue&type=style&index=0&id=4cacc0f3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cacc0f3"]])

export default __exports__